import { Link } from "react-router-dom";
import Seo from "@/lib/seo/Seo";
import { getSeoForPath } from "@/lib/seo/routes.mjs";

export default function NotFound() {
  return (
    <div className="section container-swipe text-center" data-testid="not-found-page" data-prerender-ready="true">
      <Seo {...getSeoForPath("/404")} />
      <div className="font-display text-7xl font-black text-[var(--swipe-navy)]">404</div>
      <h1 className="mt-4 font-display-tight text-3xl font-black text-[var(--swipe-navy)]">Page not found</h1>
      <p className="mt-3 text-slate-600">The page you&apos;re looking for moved or never existed.</p>
      <Link to="/" className="btn-primary-swipe mt-6 inline-flex">Back to home</Link>
    </div>
  );
}
